import reducer from "./reducer";
export { default as AnnexesPage } from "./components/index";
export { default as annexesPageReducerName } from "./constants";
export default reducer;
